import React from "react";
import styles from './PlayerSlotV2.module.css';

const EmptySlotV2: React.FC = () => {
    return (
        <div className={styles.emptySlot}>
            <div className={styles.emptySlotIcon}>+</div>
            <span className={styles.emptySlotText}>Vælg spiller</span>
        </div>
    );
};

export default EmptySlotV2;
